export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Body_Paragraph_Spacing-b9ed69e0bdb8667846d7e155537bb230.svg";